import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const MenuCrumb = ({ itemId, pageName, sectionName, sectionLink, sectionColor, className, readable, ...rest }) => {
  return (
    <div className={classNames('menu-crumb', className)} {...rest}>
      <Link key="section" title={sectionName} to={`/menu/${sectionLink || sectionName}`}>
        <i className="fas fa-square" style={{ color: sectionColor }} />
      </Link>
      <span>
        {itemId ? (
          <Link key={pageName} to={`/${pageName}`}>
            {readable || pageName}
          </Link>
        ) : (
          pageName
        )}
      </span>
      {itemId && (
        <>
          <i className="fas fa-chevron-right chev" />
          <span>{itemId || 'New'}</span>
          {/* <i className="fas fa-eye" style={{ color: 'var(--blue-9)' }} /> */}
        </>
      )}
    </div>
  );
};

export default MenuCrumb;
